const M = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTcgMmEyIDIgMCAwIDEgMiAydjFoLTJWNEg3djE1LjM4Mmw1LTIuNSA1IDIuNVYxN2gydjUuNjE4bC03LTMuNS03IDMuNVY0YTIgMiAwIDAgMSAyLTJoMTB6bTMgNnYyaDJ2MmgtMnYyaC0ydi0yaC0ydi0yaDJWOGgyeiIgIGZpbGwtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==";
export {
  M as default
};
//# sourceMappingURL=bookmark-de71b31a.mjs.map
